/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Ai_Actions_LowInputs */

const en_settings_ai_actions_low = /** @type {(inputs: Settings_Ai_Actions_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running low on AI actions`)
};

const de_settings_ai_actions_low = /** @type {(inputs: Settings_Ai_Actions_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Aktionen fast aufgebraucht`)
};

const fr_settings_ai_actions_low = /** @type {(inputs: Settings_Ai_Actions_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il te reste peu d'actions IA`)
};

const es_settings_ai_actions_low = /** @type {(inputs: Settings_Ai_Actions_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se están agotando las Acciones IA`)
};

const it_settings_ai_actions_low = /** @type {(inputs: Settings_Ai_Actions_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimangono poche azioni AI`)
};

const nl_settings_ai_actions_low = /** @type {(inputs: Settings_Ai_Actions_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lopen bijna leeg aan AI-acties`)
};

const pl_settings_ai_actions_low = /** @type {(inputs: Settings_Ai_Actions_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niedostateczna liczba akcji AI`)
};

const fi_settings_ai_actions_low = /** @type {(inputs: Settings_Ai_Actions_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-toimintoja vähissä`)
};

const da_settings_ai_actions_low = /** @type {(inputs: Settings_Ai_Actions_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Løber tør for AI-handlinger`)
};

const sv_settings_ai_actions_low = /** @type {(inputs: Settings_Ai_Actions_LowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Få AI-aktioner kvar`)
};

/**
* | output |
* | --- |
* | "Running low on AI actions" |
*
* @param {Settings_Ai_Actions_LowInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_ai_actions_low = /** @type {((inputs?: Settings_Ai_Actions_LowInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Ai_Actions_LowInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_ai_actions_low(inputs)
	if (locale === "fr") return fr_settings_ai_actions_low(inputs)
	if (locale === "es") return es_settings_ai_actions_low(inputs)
	if (locale === "it") return it_settings_ai_actions_low(inputs)
	if (locale === "nl") return nl_settings_ai_actions_low(inputs)
	if (locale === "pl") return pl_settings_ai_actions_low(inputs)
	if (locale === "fi") return fi_settings_ai_actions_low(inputs)
	if (locale === "da") return da_settings_ai_actions_low(inputs)
	if (locale === "sv") return sv_settings_ai_actions_low(inputs)
	return en_settings_ai_actions_low(inputs)
});